/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 10:04:21
 * @LastEditTime: 2019-08-14 15:39:30
 * @LastEditors: Please set LastEditors
 */
import {api} from './../api/api'

/** 省份列表查询 */
const getProList = params => api('professor/proList', params)

/** 市级列表查询 */
const getCtyList = params => api('professor/ctyList', params)

/** 区列表查询 */
const getDisList = params => api('professor/disList', params)

/** 机构列表查询 */
const getAgencyList = params => api('professor/agencyList', params)

/** 医院专家总数查询 */
const getProNum = params => api('professor/proNum', params)

/** 科室列表查询 */
const getDepartmentJson = params => api('base/department/getDepartmentJson', params)

/** 查询科室父级ID接口 */
const getDepartmentByParId = params => api('base/department/getParId', params)

/** 获取jsticket */
const getJsticket = params => api('wechat/getJsticket', params)

/** 获取活动信息 */
const getActivityInfo = params => api('activity/getActivityInfo', params)

/** 微信分享上报 */
const shareStatistics = params => api('user/shareStatistics', params)

/** 获取助考之星url */
const getZhuKaoUrl = params => api('content/getZhuKaoUrl', params)

/** 药品分享统计接口 */
const shareDrugStatistics = params => api('drug/share', params)

/** 临床指南分享统计接口 */
const shareGuideStatistics = params => api('guide/share', params)

export {
  getProList,
  getCtyList,
  getDisList,
  getAgencyList,
  getProNum,
  getDepartmentJson,
  getDepartmentByParId,
  getJsticket,
  getActivityInfo,
  shareStatistics,
  getZhuKaoUrl,
  shareDrugStatistics,
  shareGuideStatistics
}



// WEBPACK FOOTER //
// ./src/server/common/common.js